export const fetchNaturezasAtoAction = () => ({ type: 'FETCH_NATUREZAS_ATO' });
export const fetchNaturezasAtoActionSuccess = data => ({ type: 'FETCH_NATUREZAS_ATO_SUCCESS', data });
export const fetchNaturezasAtoActionError = error => ({ type: 'FETCH_NATUREZAS_ATO_ERROR', error });
